import React,
{
    useEffect,
    useState,
    useCallback
}
    from 'react'
import {
    useDispatch,
    useSelector
} from 'react-redux'
import Container from "react-bootstrap/Container"
import Button from "react-bootstrap/Button"
import { updateFieldSpecial, getParQList, updateField, getMaxClients, getParQListSpecial } from "./parQSlice";

import debounce from "lodash.debounce"
import classes from "./ParQ.module.css"
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import CenteredLoader from '../CenteredLoader/CenteredLoader';
import { selectClientsById } from '../users/usersSlice';
import ClientInfo from "./ClientInfo.js"


function ParQ() {
    const dispatch = useDispatch()
    const windowUrl = window.location.search
    const params = new URLSearchParams(windowUrl)
    const clientId = params.get('client')
    const client = useSelector(state => selectClientsById(state, clientId))

    const isTrainer = useSelector(state => state.users.current_user.account_type === "trainer");
    const accountType = useSelector(state => state.users.current_user.account_type)
    const maxClients = useSelector(state => state.parQ.maxClients)
    const parQUTList = useSelector(state => state.parQ.parQUTList)
    const parQListStatus = useSelector(state => state.parQ.parQListStatus)


    useEffect(() => {
        // PRODUCTION SITE DISPATCH, also need to change UseEffect function below
        dispatch(getParQList({ action: "getParqQuestions", client_id: clientId }))

        // SPECIAL UT DALLAS DISPATCH for testing, for production use above production
        //dispatch, also need to change below UseEffect function
        //dispatch(getParQListSpecial({ client_id: 225239, action: 'getParqQuestions' }))

        dispatch(getMaxClients())
    }, [])


    function updateDB(payload) {
        // PRODUCTION SITE DISPATCH, also need to change UseEffect above function
        dispatch(updateField(payload))

        // SPECIAL UT DALLAS DATASET DISPATCH for testing, for production use above production
        //dispatch, also need to change above UseEffect function
        //dispatch(updateFieldSpecial(payload))
    }

    const debouncedUpdateDB = useCallback(debounce((payload) =>
        updateDB(payload), 500), [])

    function print() {
        let notifications = document.querySelector(".NotificationCenter_NotificationCenter__1GlPc")
        let sideNav = document.querySelector(".App_SideContent__Rs8PF")
        let mainLayout = document.querySelector(".App_MainLayout__2X78D")

        mainLayout.style.height = "initial"
        notifications.style.display = "none";
        sideNav.style.display = "none";
        window.print();
        mainLayout.style.height = "100vh"
        notifications.style.display = "initial";
        sideNav.style.display = "initial";
    }

    function textFieldLoop(textFields, question) {
        let questionText = question.question;

        if (questionText == "Please list the family members affected/the age of onset/type/the action taken for the following ailments. (e.g. Mother/56//CAD/Nitroglycerin medication") {
            questionText = "Please list the family members affected/the age of onset/type/the action taken for the following ailments. (e.g. Mother/56/CAD/Nitroglycerin medication"
        }

        return (
            <>
                {question.question_number ? <td>{question.question_number} </td> : <td></td>}
                < td >
                    <p> {questionText} </p>
                    {
                        textFields.length > 0 && textFields.map(answerItem => {
                            let answerType;

                            if (answerItem.answer_type === "Numeric") {
                                answerType = "number"
                            } else if (answerItem.answer_type === "Textfield") {
                                answerType = "text"
                            } else {
                                answerType = answerItem.answer_type
                            }


                            let question_type = ["birthdate", "phone", "height", "height_units"
                                , "weight", "weight_units"].includes(answerItem.answer_values?.answer_id)
                                ? answerItem.answer_values?.answer_id : "standard"

                            return (
                                <>
                                    {(answerType === "Textarea") &&
                                        <textarea key={answerItem.answer_values?.answer_id}
                                            className="form-control form-control-sm"
                                            name={answerItem.answer_field_id}
                                            placeholder={answerItem.placeholder_text}
                                            onChange={(e) => {
                                                let answer = e.target.value;

                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                // let question_type = "standard"
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = answerItem?.answer_values?.integer_answer
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)
                                            }}
                                        >
                                            {answerItem.answer_values?.answer}
                                        </textarea>}

                                    {(["Textfield", "Numeric", "Date"].includes(answerItem.answer_type)) &&
                                        <input key={answerItem.answer_values?.answer_id} type={answerType}
                                            className="form-control form-control-sm"
                                            name={answerItem.answer_field_id}
                                            placeholder={answerItem.placeholder_text}
                                            defaultValue={answerItem.answer_values?.answer}
                                            onChange={(e) => {
                                                let answer = e.target.value;
                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                //let question_type = "standard"
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = answerItem?.answer_values?.integer_answer
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)
                                            }}
                                        />}
                                    {(["lbs=0,kg=1", "in=0,cm=1", "Never Taken=1,Normal=0,Abnormal=2"].includes(answerItem.answer_type)) &&
                                        <select className=" selectOption ml-1"
                                            defaultValue={answerItem.answer_values?.answer}
                                            onChange={(e) => {
                                                let answer = e.target.value;
                                                //let category = question.category_name;       
                                                let answer_field_id = answerItem.answer_field_id
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = answerItem.answer_values?.integer_answer
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)

                                            }}
                                        >
                                            <option value="0">
                                                {(answerItem.answer_values?.answer_id === "weight_units") && "lbs"}
                                                {(answerItem.answer_values?.answer_id === "height_units") && "inch"}
                                                {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Normal"}
                                            </option>
                                            <option value="1">
                                                {(answerItem.answer_values?.answer_id === "weight_units") && "kg"}
                                                {(answerItem.answer_values?.answer_id === "height_units") && "cm"}
                                                {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Never Taken"}
                                            </option>
                                            {answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2" &&
                                                <option value="2">
                                                    {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Abnormal"}
                                                </option>
                                            }
                                        </select>
                                    }
                                    {answerItem.answer_type === "Hardcoded" &&
                                        <span className="ml-3">
                                            {answerItem.answer_values?.answer_id === "age" ? <small> <i>{answerItem.answer_values?.answer}  years old </i></small> :
                                                <b>{answerItem.answer_values.answer} </b>}
                                        </span>

                                    }
                                </>)
                        })

                    }
                </td >
            </>
        )
    }

    function questionRender(question) {
        let textFields = [];
        let textTypes = ["Textfield", "Textarea", "Numeric", "Date",
            "lbs=0,kg=1", "in=0,cm=1", "Hardcoded", "Never Taken=1,Normal=0,Abnormal=2"]

        for (let item of question.answer_array) {
            let answerType = item.answer_type;
            if (textTypes.includes(answerType)) textFields.push(item)
        }

        return (
            <>
                {textFieldLoop(textFields, question)}

                {question.answer_array.map(answerItem => {
                    return (
                        <>
                            {(answerItem.answer_type === "Yes=1,No=0" || answerItem.answer_type === "Yes=1,No=0,Unsure=2") ?
                                <> <td>
                                    <input key={answerItem.id}
                                        type="radio"
                                        name={answerItem.answer_field_id}
                                        value="1"
                                        defaultChecked={answerItem.answer_values?.answer == "1" ? true : null}
                                        onChange={(e) => {
                                            let answer = e.target.value;
                                            //let category = question.category_name;
                                            let answer_field_id = answerItem.answer_field_id
                                            let question_type = "standard"
                                            let client_id = clientId;
                                            let answer_id = answerItem.answer_id;
                                            let integer_answer = answerItem.answer_values?.integer_answer
                                            //let questionNumber = question.question_id;
                                            let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                            debouncedUpdateDB(payload)

                                        }}

                                    />
                                </td>
                                    <td>
                                        <input key={answerItem.id}
                                            type="radio"
                                            value="0"
                                            defaultChecked={answerItem.answer_values?.answer === "0" ? true : null}
                                            name={answerItem.answer_field_id}
                                            onChange={(e) => {
                                                let answer = e.target.value;
                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                let question_type = "standard"
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_id;
                                                let integer_answer = answerItem.answer_values?.integer_answer
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)

                                            }}
                                        />
                                    </td>
                                    {answerItem.answer_type === "Yes=1,No=0,Unsure=2" &&
                                        <td>
                                            <input key={answerItem.id}
                                                type="radio"
                                                value="2"
                                                defaultChecked={answerItem.answer_values?.answer === "2" ? true : null}
                                                name={answerItem.answer_field_id}
                                                onChange={(e) => {
                                                    let answer = e.target.value;
                                                    //let category = question.category_name;
                                                    let answer_field_id = answerItem.answer_field_id
                                                    let question_type = "standard"
                                                    let client_id = clientId;
                                                    let answer_id = answerItem.answer_id;
                                                    let integer_answer = answerItem.answer_values?.integer_answer
                                                    //let questionNumber = question.question_id;
                                                    let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                    debouncedUpdateDB(payload)

                                                }}
                                            />
                                        </td>}
                                </>
                                :
                                null
                            }
                        </>
                    )
                })
                }
            </>
        )
    }

    return (
        <>
            <Container id="containerDiv" className={classes.printableArea2} >
                {parQListStatus === "fetching" ? <CenteredLoader /> :
                    <div className={`${classes.print}`}>
                        {/* <div style={{ textTransform: "capitalize", fontSize: "1.2rem" }} className="d-flex justify-content-end mb-3 mr-4">
                            <span className="text-secondary">
                                {isTrainer ? <span>  {`Trainer ${maxClients} Plan`} </span> : <b>  Client </b>}
                            </span>
                        </div> */}
                        <div className="mt-5">
                            {isTrainer &&
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb" style={{ backgroundColor: "transparent" }}>
                                        <li className="breadcrumb-item"><Link to="/trainer/">Client List</Link></li>
                                        <li className="breadcrumb-item"><Link to={`/clientEditor?clientId=${clientId}&`}> Edit client </Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">PAR-Q</li>
                                    </ol>
                                </nav>
                            }
                        </div>
                        <div className="d-flex justify-content-between mt-5">

                            <h2 className="d-block"> {accountType == "client" ? "Your PAR-Q" : `${client?.user_name}s PAR-Q`}  </h2>
                            <div>
                                {/* <a className="btn btn-outline-secondary btn-sm mx-1 mt-1 mt-md-2" href="#" onClick={() => print()} aria-haspopup="true" aria-expanded="false" */}
                                <Button variant="outline-secondary" onClick={() => print()} style={{ marginRight: "7px" }}
                                ><i class="fa fa-print"></i></Button>

                                {/* <a className="btn btn-success btn-sm mt-1 mt-md-2" href="#"
                                    onClick={() => alert("No need to save.  Data is automatically saved as it is entered but we added this button so users do not worry about losing their work")}
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >Save </a> */}
                                {/* <Button
                                    disabled
                                    variant="outline-success"
                                >
                                    Data is automatically saved
                                </Button> */}
                            </div>
                        </div >
                        <hr />
                        <div style={{ backgroundColor: "#f7f8f9", padding: "20px", boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)", borderRadius: "5px" }} >                        {

                            parQUTList?.clientInfo?.map(question => {
                                return (
                                    <ClientInfo question={question}
                                        clientId={clientId} debouncedUpdateDB={debouncedUpdateDB} />
                                )
                            })
                        }

                            <h4 className="text-center mt-5">Physical Activity Readiness Questionnaire (PAR-Q)</h4><br></br>

                            {Object.entries(parQUTList).map(([key, entries]) => {
                                if (key === "clientInfo") return

                                let yesNoType = false;
                                let yesNoUnsureType = false;
                                
                                parQUTList[key].forEach(item => {
                                    item.answer_array.forEach(answerItem => {
                                        if (answerItem.answer_type_id === 1) {
                                            yesNoType = true;
                                        } else if (answerItem.answer_type_id === 2) {
                                            yesNoUnsureType = true;
                                        }
                                    })
                                })

                                return (
                                    <table className="table table-bordered table-hover table-sm" id={classes.parQ}>
                                        <thead>
                                            <tr className="table-info">
                                                <th style={{ width: "inherit" }}>#</th>
                                                <th style={{ textAlign: "center" }}>{key}</th>
                                                {yesNoType && <th style={{ textAlign: "center" }}>Yes</th>}
                                                {yesNoType && <th style={{ textAlign: "center" }}>No</th>}
                                                {yesNoUnsureType && <th style={{ textAlign: "center" }}>Unsure</th>}
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                parQUTList[key]?.map(question => {
                                                    return (
                                                        <tr>{questionRender(question)}</tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>)


                            })}
                        </div>

                    </div >

                }
            </Container >
            <div style={{ margin: "20px", float: "right" }}>
                <i className="fas fa-info-circle"></i> Data is Automatically Saved
            </div>
        </>
    )
}


export default ParQ;
